import React from 'react';

function ReceiptAddress(props) {
  const {
    onChange,
    receiptAddress,
    message,
    readOnly,
  } = props;
  return (
    <div className="admin-settings-textarea">
      <textarea
        id="receipt-address"
        className="admin-settings-textarea__textarea"
        data-qa-ref="receipt-address"
        rows="4"
        cols="30"
        onChange={onChange}
        readOnly={readOnly}
        defaultValue={receiptAddress} />
      <div className="state-message"><small>{message}</small></div>
    </div>
  );
}

export default ReceiptAddress;
